import classNames from 'classnames'
import { Ref, forwardRef, useState, InputHTMLAttributes } from 'react'

import { InputProps } from './input-types'
import styles from './InputBase.module.scss'
import ErrorIndicator from '../ErrorIndicator'
import InputIndicatorTransition from '../InputIndicatorTransition'

export const InputBase = forwardRef(
    (
        {
            inputContainerClassName,
            inputClassName,
            children,
            errorMessage,
            renderError,
            adornmentRight,
            adornmentInline,
            ...props
        }: InputProps,
        ref: Ref<HTMLInputElement>,
    ) => {
        const [attributes, setAttributes] = useState<
            InputHTMLAttributes<HTMLInputElement>
        >({})

        return (
            <div className={styles.wrapper}>
                <span
                    className={classNames(
                        styles.inputContainer,
                        inputContainerClassName,
                    )}
                >
                    <input
                        ref={ref}
                        className={classNames(styles.input, inputClassName)}
                        {...props}
                        {...attributes}
                    />
                    {children}

                    {adornmentInline?.(attributes, setAttributes)}

                    <InputIndicatorTransition>
                        {errorMessage && (
                            <ErrorIndicator field={props.name ?? ''}>
                                {renderError
                                    ? renderError(errorMessage)
                                    : typeof errorMessage === 'string'
                                      ? errorMessage
                                      : errorMessage.message}
                            </ErrorIndicator>
                        )}
                    </InputIndicatorTransition>
                    {adornmentRight?.(attributes, setAttributes)}
                </span>
            </div>
        )
    },
)
InputBase.displayName = 'InputBase'
